export async function check<T>(anything: T, property: keyof T, ifMissing: () => Promise<T[keyof T]>): Promise<T> {
    if(anything[property]){

    } else {
        anything[property] = await ifMissing();
    }
    return anything;
}